export const INVESTIGATIONS_QUERY_KEY = "get-investigations";
export const INVESTIGATION_DETAILS_QUERY_KEY = "get-investigation-details";
export const INVESTIGATION_EVENTS_QUERY_KEY = "investigation-events";
export const INVESTIGATION_DRAWER_EVENTS_QUERY_KEY = "investigation-drawer-events";
export const INVESTIGATION_DRAWER_LOGS_QUERY_KEY = "investigation-drawer-logs";
export const investigationQueryKey = (...parts) => [INVESTIGATIONS_QUERY_KEY, ...parts];
export const investigationDetailsQueryKey = (investigationId, includeLogsAndEvents = false) => investigationId ? [INVESTIGATION_DETAILS_QUERY_KEY, investigationId, includeLogsAndEvents] : [INVESTIGATION_DETAILS_QUERY_KEY];
export const investigationEventsQueryKey = (...parts) => [INVESTIGATION_EVENTS_QUERY_KEY, ...parts];
export const investigationDrawerEventsQueryKey = (...parts) => [
  INVESTIGATION_DRAWER_EVENTS_QUERY_KEY,
  ...parts
];
export const investigationDrawerLogsQueryKey = (...parts) => [
  INVESTIGATION_DRAWER_LOGS_QUERY_KEY,
  ...parts
];
export const ASSETS_QUERY_KEY = "get-assets";
export const ASSET_QUERY_KEY = "get-asset";
export const assetsQueryKey = (...parts) => [ASSETS_QUERY_KEY, ...parts];
export const assetQueryKey = (...parts) => [ASSET_QUERY_KEY, ...parts];
